<template lang="pug">
  //- UNCOMMENT IF YOU DO NOT WANT PEOPLE TO INTERACT WITH THIS PART OF THE WEBAPP (and make sure to comment the other div out)
  //- div(:style="{display:'block', textAlign:'center'}")
  //-   img(src='@/assets/img/currentPositionsBlur.png' alt='usit photo' :style="{height:'40vh', borderLeftStyle:'solid'}")
  .md-layout
    .md-layout-item.md-size-100
      .md-layout
        .md-layout-item.md-size-25.md-small-size-100.md-medium-50
          md-card.md-card-stats
            md-card-header(data-background-color="red")
              md-icon person
            md-card-content
              h4.category Trading Rank
              h4.title {{portfolio_rank}}
        .md-layout-item.md-size-25.md-small-size-100.md-medium-50
          md-card.md-card-stats
            md-card-header(data-background-color="blue")
              md-icon trending_up
            md-card-content
              h4.category Returns
              h4.title {{portfolio_returns.toFixed(3)}}% 
        .md-layout-item.md-size-25.md-small-size-100.md-medium-50
          md-card.md-card-stats
            md-card-header(data-background-color="red")
              md-icon attach_money
            md-card-content
              h4.category Capital
              h4.title ${{formatNumber(portfolio_cash)}}
        .md-layout-item.md-size-25.md-small-size-100.md-medium-50
          md-card.md-card-stats
            md-card-header(data-background-color="blue")
              md-icon star_border
            md-card-content
              h4.category Holdings
              h4.title ${{formatNumber(portfolio_holdings)}} 
        //- .md-layout-item.md-size-50.md-small-size-100
        //-   p IMPLEMENT THIS GRAPH (LATER)
    .md-layout-item.md-size-100
      md-card
        md-card-header(data-background-color="green")
          h4(class="title") Manage Positions
          p(class="category") See active and past positions
        md-card-content(style="text-align: center;")
          .md-layout
            .md-layout-item.md-size-100.custom-div
              md-table
                md-table-row
                  md-table-cell <b>Stock</b>
                  md-table-cell <b>Percent Change</b>
                  md-table-cell <b>Close Date</b>
                  md-table-cell
                md-table-row(v-for="position in positions" :key="position.id")
                  md-table-cell {{position.ticker}}
                  md-table-cell {{(position.percent_delta * 100).toFixed(2)}}%
                  md-table-cell {{position.date_closed ? position.closed_date_f : 'N/A'}}
                  md-table-cell
                    md-button(v-if="position.closed" disabled) Closed
                    md-button.md-raised.md-success(v-else @click="openDialog(position)") Close Position
            .md-layout-item.md-xsmall-hide.md-small-hide
              md-table
                md-table-row
                  md-table-cell <b>Stock</b>
                  md-table-cell <b>Open Price</b>
                  md-table-cell <b>Current Price</b>
                  md-table-cell <b>Position</b>
                  md-table-cell <b>Percent Change</b>
                  md-table-cell <b>Initial Investment</b>
                  md-table-cell <b>Close Price</b>
                  md-table-cell <b>Close Date</b>
                  md-table-cell
                md-table-row(v-for="position in positions" :key="position.id")
                  md-table-cell {{position.ticker}}
                  md-table-cell ${{position.open_price}}
                  md-table-cell ${{position.current_price}}
                  md-table-cell {{getPosition(position.short)}}
                  md-table-cell {{(position.percent_delta * 100).toFixed(2)}}%
                  md-table-cell ${{position.amount}}
                  md-table-cell {{position.close_price ? `$${position.close_price}` : 'N/A'}}
                  md-table-cell {{position.date_closed ? position.closed_date_f : 'N/A'}}
                  md-table-cell
                    md-button(v-if="position.closed" disabled) Closed
                    md-button.md-raised.md-success(v-else @click="openDialog(position)") Close Position
        md-dialog(:md-active.sync="showDialog" v-on:md-closed="clearForm")
          md-dialog-title Manage Position: {{selected_ticker}}
            .md-layout
              .md-layout-item.md-size-100
                md-table
                  md-table-row
                    md-table-cell Stock
                    md-table-cell {{selected_ticker}}
                  md-table-row
                    md-table-cell Open Price
                    md-table-cell ${{selected_orig_price}}
                  md-table-row
                    md-table-cell Current Price
                    md-table-cell ${{selected_price}}
                  md-table-row
                    md-table-cell Position
                    md-table-cell {{getPosition(selected_position)}}
                  md-table-row
                    md-table-cell Percent Change
                    md-table-cell {{(selected_returns * 100).toFixed(2)}}%
                  md-table-row
                    md-table-cell Invested Amount
                    md-table-cell ${{selected_amount}}
                  md-table-row
                    md-table-cell Current Cash Value
                    md-table-cell ${{cashValue().toFixed(2)}} 
              .md-layout-item.md-size-100
                p(v-if="error" style="color: red") {{error}}
          md-dialog-actions
            md-button.md-raised(@click="showDialog = false") Cancel
            md-button.md-raised.md-success(@click="closePosition()") Close Position
          
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      user: null,
      positions: null,
      error: null,
      showDialog: null,
      selected_ticker: null,
      selected_price: null,
      selected_id: null,
      selected_returns: null,
      selected_orig_price: null,
      selected_amount: null,
      selected_position: null,
      portfolio_total: null,
      portfolio_cash: null,
      portfolio_holdings: null,
      portfolio_rank: null,
      portfolio_returns: null,
    }
  },
  created() {
    
  },
  mounted() {
    this.user = this.$store.state.user;
    this.getPositions();
    this.getPortfolio();
  },
  methods: {
    getPositions() {
      axios.get(`/api/trading/member_position`)
      .then((res) => {
        this.positions = res.data;
      }).catch((err) => {
        this.error = true;
      })
    },
    getPortfolio() {
      axios.get(`/api/trading/member_portfolio/${this.user.id}`)
      .then((res) => {
        this.portfolio_total = res.data.total;
        this.portfolio_cash = res.data.cash;
        this.portfolio_holdings = res.data.holdings;
        this.portfolio_rank = res.data.rank;
        this.portfolio_returns = res.data.returns;
      }).catch((err) => {

      });
    },
    openDialog(position) {
      this.selected_id = position.id;
      this.selected_price = position.current_price;
      this.selected_ticker = position.ticker;
      this.selected_returns = position.percent_delta;
      this.selected_orig_price = position.open_price;
      this.selected_amount = position.amount;
      this.selected_position = position.short;
      this.showDialog = true;
    },
    closePosition() {
      axios.post(`/api/trading/member_position/${this.selected_id}/close_position`)
      .then((res) => {
        this.getPositions();
        this.getPortfolio();
        this.showDialog = false;
      }).catch((err) => {
        this.error = true;
      });
    },
    clearForm() {
      this.selected_id = null;
      this.selected_price = null;
      this.selected_ticker = null;
      this.selected_returns = null;
      this.selected_orig_price = null;
      this.selected_amount = null;
      this.selected_position = null;
    },
    formatDate(datestring) {
      return datestring.toLocaleString("en-US");
    },
    formatNumber(n) {
      var parts=n.toString().split(".");
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
    },
    cashValue() {
      return this.selected_amount * (1 + 1 * this.selected_returns);
    },
    getPosition(shorted) {
      return (shorted) ? 'Short' : 'Long';
    }
  }
}
</script>

<style scoped>
  .custom-div {
    display: none;
  }

  @media screen and (max-width: 943px) {
    .custom-div {
      display: block;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/Trading/ManagePositions.vue